/**
 * Apollo design tokens / base styles as a string (esbuild inlines via text loader).
 * Kept in one file so Jest can mock this module globally without touching package exports.
 */
import apolloCss from '@xplortech/apollo-core/css/style';

export default apolloCss;
